import React, {Component} from 'react';
import {Accordion, Icon} from 'semantic-ui-react';
import headerBorder from '../../assets/images/line-orange.png';

class TermsAndConditions extends Component{
	componentDidMount = () =>{
		window.scrollTo(0, 0);
	}

	state = { activeIndex: 0 }

	handleClick = (e, titleProps) => {
		const { index } = titleProps
		const { activeIndex } = this.state
		const newIndex = activeIndex === index ? -1 : index

		this.setState({ activeIndex: newIndex })
	}
	
	render(){
		const { activeIndex } = this.state
		
		return (
			<div>
				<div className="section-content-wrapper data-privacy-wrapper">
					<div className="align-center">
						<h1 className="section-header">Official terms and conditions</h1>
						<img src={headerBorder} className="header-border" alt="" />
						<p className="para-content">Here’s everything you need to know about the terms and conditions of booking a trip with Light Miles Travel.
							Please read through carefully and get in touch if you need more detail on any point.
						</p>
					</div>
					<Accordion styled className="margin-top-2">
						<Accordion.Title active={activeIndex === 0} index={0} onClick={this.handleClick}>
							<Icon name='dropdown' /> Secure your booking
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 0}>
							<p className="para-content">
								To secure a booking, you must pay us a deposit (or make full payment if the booking is made within 30 
								days prior to start of the trip). On occasions, full payment for a service such as your flights may be 
								required at the time of booking. The applicable deposit (30% of the tour price) will be confirmed at the time 
								of booking.
							</p>
							<p className="para-content">
								When you submit your booking request, we will treat this as a ‘not-guaranteed’’ booking,
								at this point the booking is only provisional and is not confirmed. Your booking is 
								accepted and becomes definite only from the date when we send you an e-mail to confirm 
								that your ‘on request’ booking has been confirmed. It is at this point that a contract 
								between you and us comes into existence.
							</p>
							<p className="para-content">
								For bookings made via our website, any acknowledgement of your booking request we send to 
								you in the meantime is not a confirmation of your booking. Before your booking is confirmed 
								and a contract comes into force, we reserve the right to increase or decrease holiday prices.
							</p>
							<p className="para-content">
								We (and our agents) reserve the right to decline any booking at our absolute discretion.
							</p>
							<p className="para-content">
								If you book via our website, we will communicate with you by e-mail. You must accordingly check your 
								e-mails on a regular basis. We may also contact you by telephone and/or post if we cannot, for whatever 
								reason, contact you by e-mail. Certain documents may need to be sent by post. References in these 
								conditions to “send” and “in writing” or similar include communication by e-mail. You should contact 
								us by e-mail if you need to do so for any of the reasons mentioned in these booking conditions. 
								All e-mails should be sent to inquiry@lightmiles.travel.com
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 1} index={1} onClick={this.handleClick}>
							<Icon name='dropdown' /> Booking confirmation
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 1}>
							<p className="para-content">
								Your booking is confirmed and a contract exists when Light Miles Travel (LMTI) issues a 
								written confirmation after receipt of the applicable deposit amount. Please check your 
								confirmation carefully and report any incorrect or incomplete information to LMTI. Please 
								ensure that names are exactly as stated in the relevant passport.
							</p>
							<p className="para-content">
								By making a booking, the lead person on the booking agrees on behalf of all persons detailed on the 
								booking that:
							</p>

							<ul className="terms-list">
								<li className="para-content">
									he/she has read these Booking Conditions, the formal proposal, and has the authority to and does 
									agree to be bound by them;
								</li>
								<li className="para-content">
									he/she agrees and accept the risks involved in travel;
								</li>
								<li className="para-content">
									he/she consents to our use of personal data in accordance with our Privacy Policy and is authorized on behalf of all 
									persons named on the booking to disclose their personal details to us, including where applicable special categories 
									of data (such as information on health conditions or disabilities and dietary requirements);
								</li>
								<li className="para-content">
									he/she is over 18 years of age and resident in the Philippines and possess the legal authority to enter into 
									both this binding agreement and a binding agreement with Light Miles Travel, to use the Services, to purchase the 
									Product;
								</li>
								<li className="para-content">
									he/she does not suffer from any pre-existing medical condition or disability which may prevent them from 
									actively participating in the tour – if any person suffers from any medical condition or disability which 
									will or may affect their tour arrangements, please contact us before making your booking so that we can 
									advise as to the suitability of your chosen arrangements;
								</li>
								<li className="para-content">
									he/she accepts financial responsibility for payment of the booking on behalf of all persons detailed on the 
									booking.
								</li>
							</ul>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 2} index={2} onClick={this.handleClick}>
							<Icon name='dropdown' /> Your tour contract
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 2}>
							<p className="para-content">
								The contract is between you and us. We both agree that the Philippine (and no other) will apply to your 
								contract and to any dispute, claim or other matter of any description which arises between us (except as set out below). 
								We both also agree that any dispute, claim or other matter of any description (and whether or not involving any 
								personal injury) which arises between us must be dealt with by the Courts of the Philippines only. None of our 
								employees have the authority to vary or omit any of these terms. No promise of a discount or refund will be 
								binding on us unless confirmed by us in writing.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 3} index={3} onClick={this.handleClick}>
							<Icon name='dropdown' /> Modifications or changes on the booking
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 3}>
							<p className="para-content">
								You are responsible for ensuring that information provided to Light Miles Travel is accurate and up-to-date. 
								If you wish to change any part of your booking after our e-mail confirmation has been issued, you must 
								inform us in writing as soon as possible. This should be done by the lead guest. Whilst we will do our 
								best to assist, we cannot guarantee that we will be able to meet your requested change.
							</p>
							<p className="para-content">
								Where we can meet a request, an administration fee of USD 50 per booking plus any additional costs or charges 
								incurred by us or incurred or imposed by any of our suppliers will be charged, if a confirmed booking is changed 
								or transferred to a different departure date or tour, up to 90 days prior to departure. Thereafter all changes 
								will be treated as cancellations and subject to the charges. Changes are subject to availability. Where we are 
								unable to assist you and you do not wish to proceed with the original booking, we will treat this as a cancellation 
								by you. A cancellation fee may be payable in accordance with Cancellation clause.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 4} index={4} onClick={this.handleClick}>
							<Icon name='dropdown' /> Changes made by Light Miles Travel
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 4}>
							<p className="para-content">
								Light Miles Travel may modify your itinerary where reasonably required in its sole discretion. If LMTI makes a change 
								affecting at least one in three full days of the itinerary or which materially affects the character of a product 
								or service in its entirety, LMTI will provide notice to you as soon as reasonably possible, provided that there 
								is sufficient time to do so before departure. If a Change is made more than 14 days before departure, you may 
								choose to:
							</p>
							<ul className="terms-list">
								<li className="para-content">
									Accept the Change and proceed with the amended product or service;
								</li>
								<li className="para-content">
									Book another product or service of equal or greater value, if available (you will be responsible for paying 
									any difference in price); or
								</li>
								<li className="para-content">
									Book another product or service of lesser value, if available (with a refund payable to you for the
									difference in price);
								</li>
							</ul>
							<p className="para-content">
								You must notify Light Miles Travel of your choice within 10 days of receiving notice or you will be deemed to 
								accept the amended itinerary.
							</p>
							<p className="para-content">
								Once a Tour has departed, itinerary changes may be necessary as a result of unforeseen circumstances, operational concerns, 
								or concerns for your health, safety, enjoyment or comfort. Any changes are at the discretion of Light Miles Travel. You 
								acknowledge that you must have reasonable financial resources to cover incidental expenses during all travel with LMTI, 
								whether or not such expenses arise from a change of itinerary, and LMTI is not liable for your failure to prepare 
								adequately for travel and unforeseen circumstances which may arise during travel. Light Miles Travel will not be 
								liable for any indirect and or consequential losses associated with any changes to a booking or itinerary.

							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 5} index={5} onClick={this.handleClick}>
							<Icon name='dropdown' /> Airfare
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 5}>
							<p className="para-content">
								Tour prices do not include international or other airfare unless expressly mentioned in the Tour’s descriptions. 
								Light Miles Travel will quote the best price available for the travel dates requested at the time the quote is 
								prepared. Quotes provide an estimate only and are not a firm price commitment by Light Miles Travel or the 
								applicable air carrier(s).
							</p>
							<p className="para-content">
								Light Miles Travel acts only as a sales agent for the applicable air carrier and the air carrier terms and conditions 
								apply to the purchase and use of the air travel ticket. Please consult the air carrier’s applicable terms and 
								conditions and conditions of carriage for complete information including applicable cancellation terms. Light 
								Miles Travel is not responsible for changes in air itineraries or flight times and does not provide advice or 
								alerts regarding air travel tickets, flight status or delays.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 6} index={6} onClick={this.handleClick}>
							<Icon name='dropdown' /> Cutting your holiday short
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 6}>
							<p className="para-content">
								If you are forced to return home early, we cannot refund the cost of any travel arrangements you have not used. If you cut short your holiday and 
								return home early in circumstances where you have no reasonable cause for complaint about the standard of accommodation and services provided, 
								we will not offer you any refund for that part of your holiday not completed, or be liable for any associated costs you may incur. 
								Depending on the circumstances, your travel insurance may offer cover for curtailment and we suggest that any claim is made directly 
								with them.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 7} index={7} onClick={this.handleClick}>
							<Icon name='dropdown' /> Tour participation and client responsibility
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 7}>
							<p className="para-content">
								You must provide any information we ask for in good time and are responsible for providing accurate information to us. 
								It is important that you complete all information we request accurately and on time as we cannot be held responsible 
								for any problems or additional costs that may arise from any inaccurate or incomplete information that you may provide.
							</p>
							<p className="para-content">
								You agree to accept the authority and decisions of our employees, tour managers, agents and guides whilst taking part in 
								your tour. If in the opinion of any such person(s) or any other person in a position of authority, your health, 
								level of fitness or conduct at any time before or during a tour is endangering or appears likely to endanger the 
								health or wellbeing of yourself or any third party (including any other clients of ours) or the safe, comfortable 
								or happy progress of the tour, you may be excluded from all or part of the tour without refund or recompense, 
								this will also be the case where it is discovered that you have committed a criminal act (such as causing damage).
							</p>
							<p className="para-content">
								If you are excluded, we will have no further responsibility towards you (including any return travel arrangements) and we 
								will not meet any expenses or costs incurred as a result of the exclusion nor refund you for any unused services.
							</p>
							<p className="para-content">
								When you book with us, you accept responsibility for any costs (including repair, replacement and cleaning fees) incurred by 
								Light Miles Travel and its suppliers for property damage, destruction or theft caused by you while on a Tour. You agree to immediately 
								report any pre-existing damage to a representative of the Light Miles Travel and staff of the accommodation, transportation service, 
								or facility as soon as possible upon discovery.
							</p>
							<p className="para-content">
								You agree to take all prudent measures in relation to your own safety while on Tour including, but not limited to, the proper use of safety 
								devices (including seatbelts, harnesses, flotation devices and helmets) and obeying all posted signs and oral or written warnings 
								regarding health and safety. Neither Light Miles Travel nor its Third Party Suppliers are liable for loss or damages caused by your 
								failure to comply with safety instructions or warnings.
							</p>
							<p className="para-content">
								Any clients who have taken part in racist / offensive / abusive / willful misconduct or any other form of discriminatory behavior to any of our 
								clients or to any third party will be excluded from the tour and will receive no refund for any missed services or accommodation.

							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 8} index={8} onClick={this.handleClick}>
							<Icon name='dropdown' /> Our responsibility - Disclaimer of Liability
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 8}>
							<p className="para-content bold">
								Neither Light Miles Travel nor its local operator nor its agents or affiliated entities (“released parties”) shall be responsible or 
								liable for cancellations, acts of other service providers, diversions or substitution of equipment or any act, 
								variation, postponement, omission or default by air carriers, land carriers, hoteliers or hotels, transportation 
								companies, or any other persons providing services or accommodations to guests including any results thereof, such 
								as changes in services, accommodations or facilities. Nor shall they be liable for loss or damage to luggage or 
								property, or for injury, illness or death, or for any damages or claims whatsoever arising from loss, negligence 
								or delay from the act, error, omission default or negligence of any person not its direct employee or under its 
								exclusive control, including any act, error, omission, default, or negligence of any country, government or 
								governmental authority, officer or employee.
							</p>
							<p className="para-content bold">
								The released parties shall not be liable for indirect, special or consequential damages. All luggage and personal effects are at 
								all times and in all circumstances at the risk of the guided holiday participant. Light Miles Travel recommends that each guest 
								obtains luggage insurance. After return at the end of the tour, if lost articles are found and returned to the owner, a service fee 
								will be charged. The tour guides, drivers, carriers, hotels and other suppliers who provide services on guided tours are independent 
								contractors; they are not agents, employees or servants of the Operator or its associated companies. All certificates and other travel documents 
								for services issued by the Operator are subject to the terms and conditions specified by the carriers and suppliers and to the laws 
								of the countries in which the services are supplied. 
							</p>
							<p className="para-content bold">
								Carriage by sea is subject to the Carrier’s Conditions of Carriage which are expressly incorporated into this contract, copies of which 
								are available upon request. The released parties are not responsible for any criminal or other conduct by third parties, whether criminal, 
								intentional, grossly negligent, negligent or otherwise.
							</p>
							<p className="para-content">
								Light Miles Travel is not liable and will not assume responsibility for any claims, losses, damages, costs or expenses arising out of inconvenience, 
								loss of enjoyment, upset, disappointment, distress or frustration, whether physical or mental, resulting from the act or omission of any party other 
								than Light Miles Travel and its employees.
							</p>
							<p className="para-content">
								Light Miles Travel is not liable for the acts or omissions, whether negligent or otherwise, of Third Party Suppliers or any independent contractors.
							</p>
							<p className="para-content bold">
								ADDITIONAL RISKS:
							</p>
							<p className="para-content bold">
								Additional risks and dangers may arise including, but not limited to, hazards of travelling in undeveloped areas, hazards of travel 
								by boat, train, automobile, aircraft and other means of conveyance, animal interactions, forces of nature, political unrest, other unrest, 
								hazardous local customs and practices, differing levels of sanitation, differing standards of safety, risks associated with water, food, plants, 
								insects and differing animal regulation, accident or illness in areas lacking means of rapid evacuation or medical facilities, and acts of national 
								and local governments and unrest and acts of others against governments.
							</p>
							<p className="para-content bold">
								These risks are not an exhaustive list but are examples of many kinds of risks. You are voluntarily participating in these activities with the knowledge 
								that there are significant dangers involved, and you hereby agree to accept any and all risks.
							</p>
							<p className="para-content">
								As lawful consideration for the agreement with Light Miles Travel to participate in such trips and activities you 
								agree you will not make a claim against Light Miles Travel, its related companies or its personnel or sue for bodily 
								injury, emotional trauma, death, property loss or damage or other loss, cost or expense, however caused, as a result 
								of or related to your contracting for, travelling to or from, or in any and every other way participating in the 
								trip. You release Light Miles Travel, its related companies and its personnel from any and all claims, known or 
								unknown, arising from contracting for, travelling to or from, and in any and every way participating in a trip. 
								This release of liability and assumption of risk agreement is entered into on behalf of you and all members of 
								your family and party, also including minors accompanying you. This agreement also binds your heirs, legal 
								representatives and assigns.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 9} index={9} onClick={this.handleClick}>
							<Icon name='dropdown' /> For participants of minority age
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 9}>
							<p className="para-content">
								Anyone under the age of 18 on the date of first travel is considered to be a minor. Minors must always be accompanied by an adult. 
								One adult may accompany up to two minors. Unless otherwise indicated in the Tour description or by Light Miles Travel, 
								the minimum age for minors travelling on any Tour is 12 years old.
							</p>
							<p className="para-content">
								If the consent of a parent, guardian or any other person is required by applicable law for any minor to travel, the accompanying 
								adult is responsible for securing all consents, documentation and ensuring that they and the minor(s) meet all legal requirements to 
								travel, to enter into and depart from applicable countries and regions. LMTI will not be responsible for any fees, damages, or losses 
								incurred as a result of any failure to secure necessary consents, permits, and approvals.
							</p>
							<p className="para-content">
								Each adult on a booking with a minor or minor(s) is jointly and severally responsible for the behavior, wellbeing, supervision and monitoring of 
								such minor(s), and jointly and severally accepts these Terms for and on behalf of any minor(s) on their booking, including all assumptions of 
								risk and limitations of liability. Light Miles Travel does not provide care services for minors and expressly disclaims any responsibility for 
								chaperoning or controlling any minor(s).
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 10} index={10} onClick={this.handleClick}>
							<Icon name='dropdown' /> Pricing
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 10}>
							<p className="para-content">
								The price of each product/tour package will be quoted on a per-person basis, unless otherwise specified.
							</p>
							<p className="para-content">
								Prices are based on the local tariff at the time of quoting, converted at the prevailing foreign-exchange rate as 
								determined by Light Miles Travel. Price quotations are subject to change without notice, until a Booking has been made.
							</p>
							<p className="para-content">
								Unless the Supplier has otherwise specified, prices do not include any local taxes or use-fees, including 
								foreign departure, security, port charges, park fees, customs, immigration, agricultural, passenger-facility 
								charges or international transportation tax.
							</p>
							<p className="para-content">
								Inclusions are determined by Light Miles Travel. Prices may or may not include tips/gratuities; visa and processing 
								fees; baggage and personal insurance; any items of a personal nature; taxes or duties; and any beverages or food that 
								the Supplier has not specifically stated are included.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 11} index={11} onClick={this.handleClick}>
							<Icon name='dropdown' /> Price Validity
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 11}>
							<p className="para-content">
								Upon receipt of your Customized booking request, Light Miles Travel will provide you with a quote for the chosen Tour. 
								Prices quoted for all Customized Tours are valid until the date indicated on the quote, after which time LMTI reserves 
								the right to provide you with a revised quote. Any modifications to an itinerary, including dates or number of people 
								travelling, will be subject to a revised quote.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 12} index={12} onClick={this.handleClick}>
							<Icon name='dropdown' /> Accuracy of prices
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 12}>
							<p className="para-content">
								Important note: the information and prices shown on any advertising material that we issue may have changed by 
								the time you come to book your arrangements. Although we make every effort to ensure the accuracy of the information 
								and prices at the time of printing, regrettably errors do occasionally occur. You must, therefore, ensure you check 
								the price and all other details of your chosen arrangements with us at the time of booking.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 13} index={13} onClick={this.handleClick}>
							<Icon name='dropdown' /> Payment
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 13}>
							<p className="para-content">
								The confirmation sent by Light Miles Travel or your account manager will contain details of final payment required for any 
								booking. Payment of the balance of the price for any products or services booked is due 30 days before the departure date of 
								the first product or service included in the applicable booking. If full payment is not received by the applicable due date, 
								LMTI may, at its sole discretion, change the rate payable for the booking, or treat the booking as cancelled and retain the 
								deposit paid on booking as a cancellation fee. If a booking is made less than 30 days before the departure date of the first 
								product included in the applicable booking, then the full amount must be paid at the time of booking.
							</p>
							<p className="para-content">
								In addition to the deposit, certain elements of your Tour may be subject to higher or different charges (including different 
								cancellation charges). These charges will be applicable solely when required by our suppliers. If this situation arises, LMTI 
								reserves the right to ask you to make payment of the requested sum within a certain period and prior to balance due date. These 
								terms, if applicable, will be communicated to you prior to booking and will also be detailed on your invoice.
							</p>
							<p className="para-content">
								You can pay the deposit and full amount by cash, cheque, or bank deposit.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 14} index={14} onClick={this.handleClick}>
							<Icon name='dropdown' /> Currency conversions
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 14}>
							<p className="para-content">
								If Light Miles Travel provides a currency converter, currency rates are based on various publicly available sources and should be 
								used as guidelines only. Rates are not verified, and actual rates may vary. Currency quotes may not be updated on a daily basis, 
								and LMTI and its affiliates do not warrant or guarantee accuracy. LMTI shall not be liable to you if prices change due to currency. 
								LMTI recommends that you contact us if you have any questions concerning any applicable currency conversion or fees.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 15} index={15} onClick={this.handleClick}>
							<Icon name='dropdown' /> Deposit terms
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 15}>
							<p className="para-content">
								At the time of booking, a non-refundable deposit in the amount of 30% of the Tour price, per person per Tour is due to LMTI. If the booking is 
								made 60 days or less prior to departure, full payment is due at the time of booking. The non-refundable deposit should be sent to LMTI, 
								as applicable.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 16} index={16} onClick={this.handleClick}>
							<Icon name='dropdown' /> Cancellation
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 16}>
							<p className="para-content bold">
								You may cancel your booking by notifying LMTI. Cancellation fees, if any, will be determined with reference to the date on which notice of 
								cancellation is received by LMTI and are expressed as a percentage of the total price paid for the cancelled Tour, product or service (excluding 
								any insurance or air products).
							</p>
							<p className="para-content">
								Depending on the reason for the cancellation, you may be able to reclaim the cancellation charges (less any applicable excess) under the 
								terms of the insurance policy. All claims must be made direct to the insurance company. In the event of the cancellation of a booking 
								where the client is liable to pay to the Company cancellation charges in excess of the amount already paid to the Company at the time of 
								cancellation, the client cannot transfer or add these charges to another booking or use any amounts paid to us in relation to the cancelled 
								booking by way of part payment for another booking.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 17} index={17} onClick={this.handleClick}>
							<Icon name='dropdown' /> Cancellation terms
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 17}>
							<ul className="terms-list">
								<li className="para-content">
									Cancellation 60-46 days prior to arrival: 30% of the land arrangement held by LMTI in accordance with these Terms and the remainder of the 
									payments for the cancelled Tour will be refunded.
								</li>
								<li className="para-content">
									Cancellation 31-45 days prior to arrival: An amount equal to 50% of the Tour price of the cancelled Tour will be refunded.
								</li>
								<li className="para-content">
									Cancellation 16-30 days prior to arrival: An amount equal to 20% of the Tour price of the cancelled Tour will be refunded.
								</li>
								<li className="para-content">
									Cancellation within 15 days prior to arrival: No refund will be payable.
								</li>
							</ul>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 18} index={18} onClick={this.handleClick}>
							<Icon name='dropdown' /> Passports, Visas and Vaccinations
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 18}>
							<p className="para-content">
								It is your responsibility to check and fulfill the passport, visa, health and immigration requirements applicable to your itinerary. 
								We can only provide general information about this. You must check requirements for your own specific circumstances with the relevant Embassies 
								and/or Consulates and your own doctor as applicable. Requirements do change and you must check the up to date position in good time before departure.
							</p>
							<p className="para-content">
								Most countries now require passports to be valid for at least 1 year to 6 months after your return date. If your passport is in its 
								final year, you should check with the Embassy of the country you are visiting.
							</p>
							<p className="para-content">
								We do not accept any responsibility if you cannot travel, or incur any other loss because you have not complied with any passport, 
								visa, immigration requirements or health formalities. You agree to reimburse us in relation to any fines or other losses which we 
								incur as a result of your failure to comply with any passport, visa, immigration requirements or health formalities.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 19} index={19} onClick={this.handleClick}>
							<Icon name='dropdown' /> Health, disabilities and medical  conditions
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 19}>
							<p className="para-content">
								We are not a specialist disabled tour company, but we will do our utmost to cater for any special requirements you may have. 
								If you have any medical condition or disability which may affect your active participation in your tour or the tour arrangements of 
								any other person or have any special requirements as a result of any medical condition or disability (including any which affect the 
								booking process), please tell us before you confirm your booking so that we can assist you in considering the suitability of the proposed 
								tour and/or making the booking. In any event, you must give us full details at the time of booking and also update us if/when any change 
								in your condition or disability occurs.
							</p>
							<p className="para-content">
								You must also promptly advise us if any medical condition or disability which may affect your active participation in your tour or the 
								tour arrangements of any other person develops after your booking has been confirmed.
							</p>
							<p className="para-content">
								We may require you to produce a doctor’s certificate certifying that you are fit to participate in your chosen tour. Acting reasonably, if 
								we are unable to properly accommodate the needs of the person(s) concerned, we will not confirm your booking or if you did not give us 
								full details at the time of booking, we will cancel it and impose applicable cancellation charges when we become aware of these details.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 20} index={20} onClick={this.handleClick}>
							<Icon name='dropdown' /> Mandatory insurance requirements
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 20}>
							<p className="para-content">
								YOU MUST HAVE TRAVEL INSURANCE WITH A MINIMUM MEDICAL, EVACUATION AND REPATRIATION covering all applicable dates of travel with 
								Light Miles Travel. Adequate travel Insurance is mandatory and is a condition of your contract with us. You may arrange your own 
								insurance cover or purchase it from Light Miles Travel. If you opt to arrange your own insurance, then you are responsible for 
								ensuring that you have personal travel insurance with protection for the full duration of the tour in respect of at least medical 
								expenses, injury, death, repatriation, cancellation and curtailment, with adequate and appropriate cover. It is your responsibility 
								to ensure that you have sufficient coverage and comply with the terms of the applicable insurance plans. You are responsible for advising 
								your insurer of the type of travel, destination(s) and activities included in your booking so that the insurer may provide appropriate coverage.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 21} index={21} onClick={this.handleClick}>
							<Icon name='dropdown' /> Force majeure
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 21}>
							<p className="para-content">
								Light Miles Travel will not be liable in any way for death, bodily injury, illness, damage, delay or other loss or detriment to person or 
								property, or financial costs both direct and indirect incurred, or for LMTI failure to commence, perform or complete any duty owed to you 
								if such death, delay, bodily injury (including emotional distress or injury), illness, damage or other loss or detriment to person or property
								is caused by Act of God, war or war like operations, mechanical breakdowns, terrorist activities or threat thereof, civil commotions, labor 
								difficulties, interference by authorities, political disturbance, howsoever and where so ever any of the same may arise or be caused, riot, 
								insurrection and government restraint, fire, extreme weather or any other cause whatsoever beyond the reasonable control of LMTI; or an event 
								which LMTI or the Third Party Supplier of services, even with all due care, could not foresee any and all of which, individually and collectively, 
								constitute “Force Majeure”.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 22} index={22} onClick={this.handleClick}>
							<Icon name='dropdown' /> Images, marketing, and electronic communications
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 22}>
							<p className="para-content">
								You agree that, while participating in any Tour, images, photos or videos may be taken by other participants, LMTI or its representatives 
								that may contain or feature you. You consent to any such pictures being taken and grants a perpetual, royalty-free, worldwide, irrevocable 
								license to LMTI, its contractors, sub-contractors and assigns, to reproduce for any purpose whatsoever (including marketing, promotions and the 
								creation of promotional materials by or with sub-licensees), in any medium whatsoever, whether currently known or hereinafter devised, without any 
								further obligation or compensation payable to you.
							</p>
							<p className="para-content">
								When you use Light Miles Travel Website, or send e-mails, text messages, and other communications from your desktop or mobile device to us, 
								you are communicating with us electronically and agree that we may communicate with you in a variety of ways, such as by e-mail, in-app push 
								notices, or by posting notices and messages on the Website. You may unsubscribe from marketing-related e-mails by emailing unsubscribe@lightmilestravel.com, 
								however we may continue to send you non-marketing messages, such as messages related to any upcoming bookings.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 23} index={23} onClick={this.handleClick}>
							<Icon name='dropdown' /> Privacy policy
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 23}>
							<p className="para-content">
								Light Miles Travel must collect your personal information to deliver the Tour and any products or services booked. LMTI collects, uses and discloses 
								only that information reasonably required to enable the LMTI and its Third Party Suppliers to provide the particular Tour, products and/or services 
								that you have requested as described in Light Miles Travel’s Privacy Policy, which can be accessed any time at www.lightmilestravel.com/dataprivacy
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 24} index={24} onClick={this.handleClick}>
							<Icon name='dropdown' /> General provisions
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 24}>
							<p className="para-content">
								You agree that no joint venture, agency, partnership, or employment relationship exists between you and Light Miles Travel as a 
								result of these Terms of Use or use of the Services.
							</p>
							<p className="para-content">
								LMTI’s performance of these Terms of Use is subject to existing laws and legal process, and nothing contained in these Terms of Use 
								limits LMTI's right to comply with law enforcement or other governmental or legal requests or requirements relating to your use of the 
								Services or information provided to or gathered by LMTI with respect to such use. To the extent allowed by applicable law, you agree that 
								you will bring any claim or cause of action arising from or relating to your access or use of the Services within two (2) years from the 
								date on which such claim or action arose or accrued or such claim or cause of action will be irrevocably waived.
							</p>
							<p className="para-content">
								If any part of these Terms of Use is determined to be invalid or unenforceable pursuant to applicable law including, but not limited to, 
								the warranty disclaimers and liability limitations set forth above, then the invalid or unenforceable provision will be deemed superseded by 
								a valid, enforceable provision that most closely matches the intent of the original provision and the remaining provisions in these Terms of Use 
								shall continue in effect.
							</p>
							<p className="para-content">
								These Terms of Use (and any other terms and conditions referenced herein) constitute the entire agreement between you and LMTI with 
								respect to the Services and it supersedes all prior or contemporaneous communications and proposals, whether electronic, oral, or written, 
								between you and LMTI with respect to the Services. A printed version of these Terms of Use and of any notice given in electronic form shall 
								be admissible in judicial or administrative proceedings based upon or relating to these Terms of Use to the same extent and subject to 
								the same conditions as other business documents and records originally generated and maintained in printed form.
							</p>
							<p className="para-content">
								Any rights not expressly granted herein are reserved.
							</p>
						</Accordion.Content>
						<Accordion.Title active={activeIndex === 25} index={25} onClick={this.handleClick}>
							<Icon name='dropdown' /> Complaints
						</Accordion.Title>
						<Accordion.Content active={activeIndex === 25}>
							<p className="para-content">
								We make every effort to ensure that your tour arrangements run smoothly but if you do have a problem during your tour, please 
								inform our Tour Guide/Tour Manager immediately who will endeavor to put things right. If your complaint is not resolved locally, 
								please contact us via email inquiry@lightmilestravel.com

							</p>
							<p className="para-content">
								If the problem cannot be resolved and you wish to complain further, you must send formal written notice of your complaint to us at our 
								office within 15 days of the end of your stay, giving your booking reference and all other relevant information. Please keep your letter 
								concise and to the point. This will assist us to quickly identify your concerns and speed up our response to you.
							</p>
							<p className="para-content">
								Failure to follow the procedure set out in this clause may affect ours and the applicable supplier’s ability to investigate your complaint, 
								and will affect your rights under this contract.
							</p>
						</Accordion.Content>

					</Accordion>
				</div>
			</div>
		);
	}
}

export default TermsAndConditions;